import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

import PageContainer from "../../../components/PageContainer";
import { getInvoicesService, payInvoiceService } from "./invoice.api";
import {
  checkValue,
  convertNumToFa,
  getDateString,
} from "../../../constant/helper";
import { Button, Col, Form, Input, Row, Select, message } from "antd";
import {
  getBankGatewayService,
  getWalletBalanceService,
  handlePaymentService,
  setValidationUserLogService,
} from "../../transactions/transactions.api";
import { DiscountType } from "../../../constant/Types";
import BottomSheet from "../../../components/BottomSheet";

const Invoice = () => {
  const { sessionId, rootType } = useParams();
  const chatLink = `/consultation/${rootType}/${sessionId}`;
  const [invoice, setInvoice] = useState();
  const [loading, setLoading] = useState(true);

  const discountInputRef = useRef();
  const [balance, setBalance] = useState(0);
  const [discountCode, setDiscountCode] = useState("");
  const [loadingValidateDiscount, setLoadingValidateDiscount] = useState(false);
  const [showDiscountBox, setShowDiscountBox] = useState(false);
  const [PayableValue, setpayableValue] = useState(0);
  const [paymentPopup, setPaymentPopup] = useState(false);
  const [discountDetail, setDiscountDetail] = useState({
    discountCode: "",
    discountPrice: 0,
    finalPrice: 0,
    discountType: { value: 0, type: DiscountType.PERCENT },
  });
  const [paymentForm, setPaymentForm] = useState({
    amount: "",
    clientCallbackUrl: window.location.href,
    bankGatewayId: "",
    description: "پرداخت صورتحساب",
    walletTransactionType: "DEPOSIT",
  });
  const [bankGateways, setBankGateways] = useState([]);

  useEffect(() => {
    setLoading(true);
    getInvoicesService(sessionId)
      .then((resp) => {
        if (resp.data.length > 0) setInvoice(resp.data[0]);
      })
      .finally(() => setLoading(false));
  }, [sessionId]);

  useEffect(() => {
    setLoading(true);
    getWalletBalanceService()
      .then((resp) => {
        setBalance(resp.data.balance);
      })
      .catch((error) => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    getBankGatewayService()
      .then((resp) => {
        const { content } = resp.data;
        setBankGateways(content);

        if (content.length > 0) {
          setPaymentForm((pre) => ({
            ...pre,
            bankGatewayId: content[0]["id"],
          }));
        }
      })
      .catch((error) => {
        message.error("دریافت لیست بانک ها با خطا مواجه شد!");
      });
  }, []);

  const handleValidateDiscountCode = () => {
    if (!checkValue(discountCode)) {
      message.error("کد تخفیف را وارد نمایید");
    } else {
      discountInputRef.current && discountInputRef.current.blur();
      setLoadingValidateDiscount(true);
      setShowDiscountBox(false);

      setValidationUserLogService(discountCode, invoice?.price)
        .then((res) => {
          if (res.hasOwnProperty("data")) {
            setDiscountDetail({
              ...discountDetail,
              discountCode: discountCode,
              finalPrice: res.data.paymentAmount,
              discountPrice: res.data.discountAmount,
              discountType: res.data.type,
            });

            setShowDiscountBox(true);
          } else {
            message.error("کد تخفیف نا معتبر است");
          }
        })
        .catch((err) => {
          if (err.response.status === 404) {
            // message.error("کد تخفیف نا معتبر است");
          } else if (
            err.response.status === 400 &&
            err.response.data.errors[0].message ===
              "Discount code has been expired."
          ) {
            message.error("کد تخفیف منقضی شده است ");
          } else {
            message.error("خطا در دریافت اطلاعات");
          }
        })
        .finally(() => setLoadingValidateDiscount(false));
    }
  };

  function payUp() {
    let payableValue = Number(invoice?.price);
    if (showDiscountBox && !isNaN(discountDetail.finalPrice)) {
      payableValue = discountDetail.finalPrice;
    }

    if (Number(balance) < payableValue) {
      setpayableValue(payableValue);
      setPaymentPopup(true);
    } else {
      payInvoice();
    }
  }

  function payInvoice() {
    if (!invoice || !invoice.id) return;
    let params = {
      invoiceId: invoice.id,
    };

    if (showDiscountBox && discountDetail.discountCode)
      params = { ...params, coupon: discountDetail.discountCode };

    payInvoiceService(params)
      .then((resp) => {
        message.success("پرداخت با موفقیت انجام شد");
        window.location.href = window.location.href.replace("/invoice", "");
      })
      .catch((e) => {
        message.error("پرداخت با خطا مواجه شد");
      });
  }

  function handleChangePaymentForm(value = "", prop = "price") {
    setPaymentForm({ ...paymentForm, [prop]: value });
  }

  const directPurchase = () => {
    if (PayableValue - balance > 1999) {
      handlePaymentService({
        amount: PayableValue - balance,
        bankGatewayId: paymentForm.bankGatewayId,
        clientCallbackUrl: window.location.href.replace("/invoice", ""),
        ...(discountDetail.discountCode
          ? { coupon: discountDetail.discountCode }
          : {}),
        relatedId: invoice.id,
        relatedType: "SESSION_INVOICE",
        walletTransactionType: "DEPOSIT_FOR_DIRECT_BUY",
        description: paymentForm.description,
      })
        .then((response) => {
          window.location.replace(response.data.paymentLink);
        })
        .catch((error) => {
          message.error("مشکل در پرداخت");
        });
    } else {
      message.error(
        "پرداخت مبلغ کمتر از 2000 تومان از درگاه بانکی ممکن نیست . برای ادامه ابتدا از بخش کیف پول موجودی خود را افزایش دهید"
      );
    }
  };

  return (
    <PageContainer
      classNames="invoice"
      headerProps={{
        link: chatLink,
        content: "پرداخت صورتحساب",
        className: "",
      }}
      loading={loading}
    >
      <div className="details">
        <div className="item">
          <div className="title">عنوان: </div>
          <div className="value">{invoice?.title}</div>
        </div>
        <div className="item">
          <div className="title">مبلغ: </div>
          <div className="value">
            {invoice?.price &&
              convertNumToFa(invoice.price.toLocaleString("fa"))}
          </div>
        </div>
        <div className="item">
          <div className="title">تاریخ ایجاد: </div>
          <div className="value">
            {invoice?.createdAt &&
              convertNumToFa(getDateString(invoice.createdAt))}
          </div>
        </div>
      </div>

      <Row className="mt-4">
        <Col span={24}>
          <Input
            ref={discountInputRef}
            className="discount-code"
            placeholder="کد تخفیف"
            name="discountCode"
            disabled={loadingValidateDiscount}
            value={discountCode}
            onChange={(event) => setDiscountCode(event.target.value)}
            suffix={
              <Button
                className="discount-button"
                disabled={loadingValidateDiscount}
                onClick={handleValidateDiscountCode}
              >
                اعمال
              </Button>
            }
          />
        </Col>
      </Row>

      <Row className="mt-4">
        <Col span={24}>
          <div className="total-price">
            <div className="title">کیف پول:</div>
            <div className="text">
              <strong>{convertNumToFa(balance.toLocaleString("fa"))}</strong>
              <small> ریال</small>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col span={24}>
          <div className="total-price">
            <div className="title">هزینه قابل پرداخت:</div>
            <div className="text">
              <strong>
                {invoice?.price
                  ? convertNumToFa(invoice.price.toLocaleString("fa"))
                  : "-"}
              </strong>
              <small> ریال</small>
            </div>
          </div>
        </Col>
      </Row>
      {showDiscountBox && (
        <Row>
          <Col span={24}>
            <div className="discount-box">
              <div className="discount-percent">
                <span>
                  {convertNumToFa(
                    discountDetail.discountType?.value.toLocaleString("fa")
                  )}
                  {discountDetail.discountType.type === DiscountType.PERCENT
                    ? "%"
                    : " ریال"}
                </span>
              </div>
              <div className="discount-details">
                <div className="discount-rows">
                  <div className="discount-title">
                    {discountDetail.discountCode}
                  </div>
                  <div
                    className="close-btn"
                    onClick={(event) => {
                      message.success("کد تخفیف لغو شد");
                      setDiscountCode("");
                      setShowDiscountBox(false);
                      setDiscountDetail({
                        discountCode: "",
                        discountPrice: 0,
                        finalPrice: 0,
                        discountType: { value: 0, type: DiscountType.PERCENT },
                      });
                    }}
                  >
                    <span className="icon-cancel" />
                  </div>
                </div>
                <div className="discount-rows">
                  <div className="title">تخفیف:</div>
                  <div className="text discount-amount">
                    <strong>
                      {convertNumToFa(
                        discountDetail.discountPrice.toLocaleString("fa")
                      )}
                    </strong>
                    <small>ریال</small>
                  </div>
                </div>
                <div className="discount-rows">
                  <div className="title">هزینه قابل پرداخت:</div>
                  <div className="text">
                    <strong className="final-price">
                      {convertNumToFa(
                        discountDetail.finalPrice.toLocaleString("fa")
                      )}
                    </strong>
                    <small>ریال</small>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      )}

      <div className="submit-btn center-text mt-4 pt-2 pb-15">
        <Form.Item>
          <Button
            type="primary"
            shape="round"
            htmlType="submit"
            onClick={payUp}
          >
            {discountDetail.discountCode
              ? discountDetail.finalPrice > balance &&
                discountDetail.finalPrice !== 0
                ? `پرداخت`
                : `پرداخت با کیف پول`
              : invoice?.price > balance
              ? `پرداخت`
              : `پرداخت با کیف پول`}
          </Button>
        </Form.Item>
      </div>

      <BottomSheet
        setClose={() => setPaymentPopup(false)}
        isOpen={paymentPopup}
        classNames={"payment-popup-transactions"}
        viewerClassName={"payment-popup-transactions-viewer right-text"}
      >
        <Row justify="center">
          <Col span={18}>
            <h3> افزایش اعتبار حساب کاربری (ریال) </h3>
            <div className="center-text">
              <div className={"mt-3"}>
                <Select
                  size="large"
                  value={paymentForm.bankGatewayId}
                  onChange={(value) => {
                    handleChangePaymentForm(value, "bankGatewayId");
                  }}
                >
                  {bankGateways &&
                    bankGateways.map((i) => (
                      <Select.Option value={i.id} key={i.id}>
                        {i.name ? i.name : i.type}
                      </Select.Option>
                    ))}
                </Select>
              </div>
              <div className={"submit-btn mt-3"}>
                <Button type="primary" onClick={directPurchase}>
                  پرداخت
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </BottomSheet>
    </PageContainer>
  );
};

export default Invoice;
